'use client';

import { createContext, useContext, type MouseEvent } from 'react';
import type { OpenMainContentTabInput } from '../../../store/layoutStore';

export type AssetsTableScreenshotPage = {
  id: string;
  url: string;
  signedUrl: string | null;
};

export type AssetsTableScreenshotRequest =
  | { source: 'webpage'; page: AssetsTableScreenshotPage }
  | {
      source: 'endpoint';
      endpointId: string;
      page: AssetsTableScreenshotPage;
    };

export type AssetsTableContextValue = {
  selectedAssetIds: ReadonlySet<string>;
  loadedAssetIds: readonly string[];
  collapsedGroupKeys: ReadonlySet<string>;
  newAssetIds: ReadonlySet<string>;
  onSetAssetIdsSelected: ({
    assetIds,
    selected,
  }: {
    assetIds: readonly string[];
    selected: boolean;
  }) => void;
  onSelectAllLoaded: (selected: boolean) => void;
  onToggleGroupCollapsed: (groupKey: string) => void;
  onOpenTab: (tab: OpenMainContentTabInput) => void;
  onOpenTabContextMenu: ({
    event,
    tab,
  }: {
    event: MouseEvent<HTMLElement>;
    tab: OpenMainContentTabInput;
  }) => void;
  onViewGraph: (endpointId: string) => void;
  onOpenScreenshots: (request: AssetsTableScreenshotRequest) => void;
};

const AssetsTableContext = createContext<AssetsTableContextValue | null>(null);

export const AssetsTableContextProvider = AssetsTableContext.Provider;

export function useAssetsTableContext(): AssetsTableContextValue {
  const value = useContext(AssetsTableContext);

  if (!value) {
    throw new Error(
      'useAssetsTableContext must be used inside AssetsTableContextProvider',
    );
  }

  return value;
}
